/** Created by azhou on 2019/2/26.*/
<template>
    <div>
      <t-center v-if="userInfo.type===2 && !isGroup" @goOrderLists="goOrderLists" @OrderHandle="OrderHandle"/>
      <h-center v-if="$GFUN.isInArray([3,5],userInfo.type) && !isGroup" @goFinancial="goFinancial" @goOrderLists="goOrderLists" @OrderHandle="OrderHandle"/>
      <s-center v-if="$GFUN.isInArray([6,8],userInfo.type) && !isGroup" @goFinancial="goFinancial" @goOrderLists="goOrderLists" />
      <a-center v-if="userInfo.type===99" @goOrderLists="goOrderLists" @OrderHandle="OrderHandle"/>
      <h-group-center v-if="isGroup" @goOrderLists="goOrderLists" @OrderHandle="OrderHandle"/>
      <div class="bg-white rounded box-shadow mt-5 p-3">
        <h4 class="text-left p-3 border-bottom mb-3">{{Title}}</h4>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <transition-group name="list-complete">
          <div v-for="(Itemize,index) in orderLists" :key="index+1" class="list-complete-item" tag="div">
            <itemize-admin :Itemize="Itemize" v-if="userInfo.type==99"/>
            <!-- <itemize-travel :Itemize="Itemize" v-if="userInfo.type==2"/> -->
            <itemize-hotel :Itemize="Itemize" v-if="userInfo.type==3||userInfo.type==2" />
            <itemize-homestay :Itemize="Itemize" v-if="userInfo.type==5"/>
            <itemize-scenic :Itemize="Itemize" v-if="$GFUN.isInArray([6,8],userInfo.type)"/>
          </div>
        </transition-group>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import TCenter from './CenterIndex/TCenter'
  import HCenter from './CenterIndex/HCenter'
  import SCenter from './CenterIndex/SCenter'
  import ACenter from './CenterIndex/ACenter'
  import HGroupCenter from './CenterIndex/HGroupCenter'
  import ItemizeAdmin from './CenterIndex/ItemizeAdmin'
  import ItemizeHotel from './CenterIndex/ItemizeHotel'
  import ItemizeTravel from './CenterIndex/ItemizeTravel'
  import ItemizeScenic from './CenterIndex/ItemizeScenic'
  import ItemizeHomestay from './CenterIndex/ItemizeHomestay'

  export default {
    name: 'CenterIndex',
    computed: {
      ...mapState(['IndexData']),
      ...mapGetters(['userInfo','isGroup']),
      Title() {
        switch (this.userInfo.type) {
          case 99: return '待收款订单';
          default: return this.IndexData.name
        }
      },
      titleArr() {
        switch (this.userInfo.type) {
          case 2:
          case 3:
            return ['名称','出行时间','出行人数','订单类型','成交时间','订单状态']
          case 5:
            return ['采购商','入住日期','入住人数','下单时间','订单状态']
          case 6:
            return ['门店名称','出行时间','出行人数','订单类型','下单时间','订单状态']
          case 8:
            return ['采购商','出行日期','发单时间','订单状态']
          case 99:
            return ['门店名称','出行时间','入住人数','订单类型','成交时间','订单状态']
          default:return []
        }
      }
    },
    data() {
      return {
        orderLists:[],        //滚动展现的列表
        addIndex:10,          //往滚动列表中push的index索引
      }
    },
    watch:{
      'IndexData.order'(newVal) {

      }
    },
    components:{ItemizeHomestay, ItemizeScenic, ItemizeTravel, ItemizeHotel, ItemizeAdmin, HGroupCenter, ACenter, SCenter, TCenter,HCenter},
    async created() {
      await this.getUserIndexData();
      this.orderLists = this.IndexData.list.slice(0,10);
      this.scrollList();
    },
    destroyed() {
      clearInterval(this._timer);
    },
    methods:{
      ...mapActions(['getUserIndexData']),
      //去订单列表
      goOrderLists(type,status = 'all',pay_flag = '') {
        this.$router.push({name:'OrderLists',query:{page:1,orderStatus:status,orderType:3,pay_flag:pay_flag},num:'order'})
      },
      //去待报价列表
      OrderHandle(type,status = 'all') {
        this.$router.push({name:'OrderHandle',query:{page:1,orderStatus:status,orderType:type},num:'order'})
      },
      //去资金列表
      goFinancial(tab) {
        this.$router.push({name:'FinancialLists',query:{page:1,tab}})
      },
      //轮播订单列表
      scrollList() {
        let newOrder = [...this.IndexData.list],pastItem;
        console.log(newOrder);
        this._timer = setInterval(() => {
          //当pop返回的对象不存在时，代表数组已经被切完了，重新赋值
          pastItem = newOrder.pop();
          if (pastItem) {
            this.orderLists.unshift(pastItem);
            this.orderLists.pop();
          } else newOrder = [...this.IndexData.list];
        },3000)
      }
    }
  }
</script>
<style scoped>
  .list-complete-item {
    transition: all 2s;
    width: 100%;
  }
  .list-complete-enter,.list-complete-leave-to{
    opacity: 0;
    transform: translateY(30px);
    transition: all 1s ease
  }
  .list-complete-leave-active {
    position: absolute;
    
    list-style: none;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
